import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IParkingTypeList } from '../../../Pages/Tariff/IParkingType';

export const ParkingTypeSlicer = createSlice({
  name: 'ParkingType',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IParkingTypeList[]>,
  reducers: {
    getParkingType: (state) => {
      state.isLoading = true;
    },
    successGetParkingType: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetParkingType: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getParkingType, failureGetParkingType, successGetParkingType } =
  ParkingTypeSlicer.actions;

export default ParkingTypeSlicer.reducer;
